import React from 'react';

export default function Form() {
  return (
    <>
     <div className="container mb-5" style={{ marginTop: '6rem', padding: '2rem',  borderRadius: '10px' }}>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <form className="p-5 border rounded bg-light" style={{ background: '#fff8dc', border: '1px solid #d2b48c', borderRadius: '10px', boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)' }}>
              <h2 className="text-center mb-4" style={{ fontFamily: 'cursive', fontSize: '36px', color: '#8b4513' }}>Contact </h2>

              <div className="mb-4">
                <input
                  type="text"
                  className="form-control"
                  id="defaultContactFormName"
                  placeholder="Name"
                  style={{ border: '1px solid #d2b48c' }}
                />
              </div>

              <div className="mb-4">
                <input
                  type="email"
                  className="form-control"
                  id="defaultContactFormEmail"
                  placeholder="E-mail"
                  style={{ border: '1px solid #d2b48c' }}
                />
              </div>

              <div className="mb-4">
                <label htmlFor="defaultContactFormSubject" className="form-label">
                  Subject
                </label>
                <select className="form-select" id="defaultContactFormSubject" style={{ border: '1px solid #d2b48c' }}>
                  <option value="" disabled>
                    Choose option
                  </option>
                  <option value="1">Feedback</option>
                  <option value="2">Report a bug</option>
                  <option value="3">Feature request</option>
                  <option value="4">Other</option>
                </select>
              </div>

              <div className="mb-4">
                <label htmlFor="exampleFormControlTextarea2" className="form-label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea2"
                  rows="3"
                  placeholder="Message"
                  style={{ border: '1px solid #d2b48c' }}
                ></textarea>
              </div>

              <div className="mb-4 form-check">
                <input type="checkbox" className="form-check-input" id="defaultContactFormCopy" style={{ border: '1px solid #d2b48c' }} />
                <label className="form-check-label" htmlFor="defaultContactFormCopy" style={{ color: '#8b4513' }}>
                  Send me a copy of this message
                </label>
              </div>

              <button type="submit" className="btn btn-primary btn-block" style={{ background: '#8b4513', border: '1px solid #8b4513' }}>Send</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
